/**
 * How the AI chat surface is presented in the authenticated app shell.
 */
export const AiChatDisplayMode = {
  /** Floating bubble panel pinned to the bottom-right corner. */
  BUBBLE: 'BUBBLE',
  /** Docked copilot column that takes its own space on the right. */
  DOCKED: 'DOCKED',
  /** Chat surface hidden entirely. */
  HIDDEN: 'HIDDEN'
} as const;

export type AiChatDisplayMode = (typeof AiChatDisplayMode)[keyof typeof AiChatDisplayMode];
